/**
 * Utility that will prevent the body of the page scrolling
 */
define(['jquery'], ($) => {
    const $body = $('body');
    const toggleClass = 'no-scroll';

    return (enable) => {
        // Need to use jQuery with the toggleClass, as IE11 doesn't support second argument to `toggle` on `classlist`
        $body.toggleClass(toggleClass, !enable);
    };
});
